import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserRegistrationFormValidator from './views/UserRegistrationFormValidator';

export default class UserRegistrationNode extends NodeModule {
  start(options) {
    console.log('Starting User Registration');
    const userRegistration = new Form({el: options.el, formEl: '#userForm', type: (opts) => new UserRegistrationFormValidator(opts)});
  }
}